import React from 'react'
import Header from '../Header/Header'
import ScienceComp from './ScienceComp'
import Footer from '../Footer/Footer'

function Science() {
  return (
    <>
    <Header/>
    <ScienceComp/>
    <Footer/>
    </>
  )
}

export default Science